import React, { useState } from 'react';
import { usePreloadSlot } from '../UnicronApp/preloader/PreloadSlot';
import { useLocalStorage } from '../common/hooks/useLocalStorage';
import { addQueryParams } from '../common/routing/addQueryParams';
import { useBrowser } from '../common/services/BrowserService';
import { LocationBox } from '../corporate/search/LocationBox/LocationBox';
import { SuburbType } from '../corporate/search/LocationBox/SuburbType';
import {
  DogFoodWrapper,
  FlagDetail,
  FlagHeading,
  FlagSubHeading,
  generateBackground,
  StatusIndicator,
  StyledBowl,
} from './Dogfood.styles';
import { FlagRollout } from './FlagRollout';
import { FlagrSnapshotSlot } from './preload/FlagrSnapshotSlot';

export const TELEPORT_LS_KEY = 'teleport_ls_key';

export const DogFood = () => {
  const flags = usePreloadSlot(FlagrSnapshotSlot);

  const { window } = useBrowser();

  const [showFlags, setShowFlags] = useState(false);

  const toggleShowFlags = () => setShowFlags(!showFlags);

  const pageUrl = window?.location.href ?? '';

  const [teleportLocation, setTeleportLocation] = useLocalStorage<SuburbType | null>(
    TELEPORT_LS_KEY,
    null,
  );

  if (!flags || flags.length === 0) return null;

  return (
    <DogFoodWrapper expanded={showFlags} bgColor={generateBackground()}>
      <StyledBowl onClick={toggleShowFlags} />
      {showFlags && (
        <>
          <p>
            Hey Healthengineer! Good on you for{' '}
            <a
              href="https://en.wikipedia.org/wiki/Eating_your_own_dog_food"
              rel="noreferrer"
              target="_blank"
            >
              eating your own dogfood.
            </a>{' '}
            This info is only visible to staff. Below you can see all the new and upcoming features
            we’re experimenting with.
          </p>
          <h4>
            <a href={addQueryParams(pageUrl, { includeTestProfiles: 'true' })}>
              Include Test Profiles
            </a>
          </h4>
          <h3>Teleport to a location</h3>
          <LocationBox
            onSelection={setTeleportLocation}
            value={
              teleportLocation
                ? `${teleportLocation.name}, ${teleportLocation.state}, ${teleportLocation.postcode}`
                : ''
            }
          />
          {teleportLocation && (
            <input type="button" value="Clear Teleport" onClick={() => setTeleportLocation(null)} />
          )}

          {flags.map((flag, idx) => {
            const activateUrl = addQueryParams(pageUrl, { [`flag-${flag.key}`]: 't' });
            return (
              <FlagDetail key={idx}>
                <FlagHeading>
                  <StatusIndicator enabled={flag.enabled}>⬤</StatusIndicator> {flag.description}
                </FlagHeading>
                <a href={activateUrl}>
                  <FlagSubHeading>Key: {flag.key}</FlagSubHeading>
                </a>
                <FlagRollout flag={flag} />
              </FlagDetail>
            );
          })}
        </>
      )}
    </DogFoodWrapper>
  );
};
